import sendReportRequest from './sendReportRequest';

const fetchReportSalesCategory = async ({ dateRange, from, to, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/salesByCategory',
    dateRange,
    from,
    to,
    reportingType,
  });

  return reponseData;
};

export default fetchReportSalesCategory;
